import type { CatalogEvent } from "@/features/catalog/mediators/catalogEvents";
import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";

export type CatalogLayoutEvent = Extract<
  CatalogEvent,
  { type: "catalog/layout-initialization-requested" }
>;

export function createCatalogLayoutMediator(
  runEffect: (event: CatalogLayoutEvent) => void,
): Mediator<Record<string, never>, CatalogLayoutEvent, CatalogLayoutEvent> {
  return createMediator<
    Record<string, never>,
    CatalogLayoutEvent,
    CatalogLayoutEvent
  >(
    {},
    (state, event) => ({
      status: "handled",
      state,
      effects: [event],
    }),
    { runEffect },
  );
}
